const DataIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <g className='dark:child:stroke-primary-500' clipPath='url(#clip0_4_155)'>
      <path
        d='M3 13.125C3 12.504 3.504 12 4.125 12H6.375C6.996 12 7.5 12.504 7.5 13.125V19.875C7.5 20.496 6.996 21 6.375 21H4.125C3.82663 21 3.54048 20.8815 3.3295 20.6705C3.11853 20.4595 3 20.1734 3 19.875V13.125ZM9.75 8.625C9.75 8.004 10.254 7.5 10.875 7.5H13.125C13.746 7.5 14.25 8.004 14.25 8.625V19.875C14.25 20.496 13.746 21 13.125 21H10.875C10.5766 21 10.2905 20.8815 10.0795 20.6705C9.86853 20.4595 9.75 20.1734 9.75 19.875V8.625ZM16.5 4.125C16.5 3.504 17.004 3 17.625 3H19.875C20.496 3 21 3.504 21 4.125V19.875C21 20.496 20.496 21 19.875 21H17.625C17.3266 21 17.0405 20.8815 16.8295 20.6705C16.6185 20.4595 16.5 20.1734 16.5 19.875V4.125Z'
        stroke='#91B1BE'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

export default DataIcon;
